"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sample = void 0;
const BaseAggregator_1 = require("./BaseAggregator");
class Sample extends BaseAggregator_1.BaseAggregator {
    init(start) {
        return start;
    }
    put(state, term) {
        // First value is our sample
        return state;
    }
    result(state) {
        return state;
    }
}
exports.Sample = Sample;
//# sourceMappingURL=Sample.js.map